import script from "./WhiteListModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhiteListModal.vue?vue&type=script&lang=ts&setup=true"

import "./WhiteListModal.vue?vue&type=style&index=0&id=b5ed89e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ed89e0"]])

export default __exports__